var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-root"},[_c('AppHeader',{attrs:{"categories":_vm.categories}}),_c('main',{staticClass:"main-content"},[_c('router-view',{attrs:{"categories":_vm.categories}})],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }